let sliders = {
    init: function () {
        $('#hero_banner').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.banner-dots'),
            arrow: true,
            appendArrows: $('.banner-controls'),
            prevArrow: '<div class="arrow-prev"></div>',
            nextArrow: '<div class="arrow-next"></div>',
            adaptiveHeight: true,
        });

        $('.testimonials').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.testimonial-dots'),
            arrow: true,
            appendArrows: $('.testimonial-controls'),
            prevArrow: '<div class="arrow-prev"></div>',
            nextArrow: '<div class="arrow-next"></div>',
            adaptiveHeight: true,
        });
    },
};

$(document).ready(function () {
    let Sliders = Object.create(sliders);
    Sliders.init();
});
